export default __webpack_public_path__ + "static/media/img_08.ad5b6831.jpg";